<script lang="ts">
	import { trackEvent } from '$lib/utils/mixpanel';
	import Button from './Button.svelte';
	import Progress from './Progress.svelte';
	import Score from './Score.svelte';
	import Step1 from './Step1.svelte';
	import Step10 from './Step10.svelte';
	import Step2 from './Step2.svelte';
	import Step3 from './Step3.svelte';
	import Step4 from './Step4.svelte';
	import Step5 from './Step5.svelte';
	import Step6 from './Step6.svelte';
	import Step7 from './Step7.svelte';
	import Step8 from './Step8.svelte';
	import Step9 from './Step9.svelte';

	let currentStep = $state(0);
	let monthlyIncome: number = $state(5000);
	let sufficientEmergencyFund: boolean | undefined = $state();
	let sufficientSavings: boolean | undefined = $state();
	let sufficientCiInsurance: boolean | undefined = $state();
	let sufficientTpdInsurance: boolean | undefined = $state();
	let sufficientInsuranceSpend: boolean | undefined = $state();
	let sufficientIncomeInvestment: boolean | undefined = $state();
	let sufficientNetworthInvestment: boolean | undefined = $state();
	let sufficientCpfForFrs: boolean | undefined = $state();
	let multipleIncomeStreams: boolean | undefined = $state();

	let minimumEmergencyFund = $derived(monthlyIncome * 3);
	let minimumSavings = $derived(monthlyIncome * 0.1);
	let minimumCiInsurance = $derived(monthlyIncome * 48);
	let minimumTpdInsurance = $derived(monthlyIncome * 108);
	let minimumInsuranceSpend = $derived(monthlyIncome * 0.15);
	let minimumIncomeInvestment = $derived(monthlyIncome * 0.1);
</script>

<svelte:head>
	<link rel="preconnect" href="https://fonts.googleapis.com" />
	<link rel="preconnect" href="https://fonts.gstatic.com" crossorigin="anonymous" />
	<link
		href="https://fonts.googleapis.com/css2?family=Raleway:ital,wght@0,800;1,800&display=swap"
		rel="stylesheet"
	/>
</svelte:head>

<div class="md:p-4">
	<header class="h2 mb-6">POSB Money Habits Tracker</header>

	<div class="mx-auto max-w-lg">
		{#if currentStep === 0}
			<p class="body-bold mb-3">Ready to Improve Your Money Habits?</p>
			<p class="body-regular mb-3">
				Building strong money habits is essential for achieving financial wellness.
			</p>

			<p class="body-bold mb-3">Answer a few simple questions to:</p>
			<ul class="mb-5 grid gap-2">
				<li>🔍 Check your financial well-being</li>
				<li>📈 Track your progress</li>
				<li>💡 Gain practical tips</li>
			</ul>
			<Button
				click={() => {
					currentStep++;
					trackEvent('Money Habits Tracker - Start');
				}}>START NOW</Button
			>
		{:else if currentStep === 11}
			<Score
				{sufficientEmergencyFund}
				{sufficientSavings}
				{sufficientCiInsurance}
				{sufficientTpdInsurance}
				{sufficientInsuranceSpend}
				{sufficientIncomeInvestment}
				{sufficientNetworthInvestment}
				{sufficientCpfForFrs}
				{multipleIncomeStreams}
			/>
		{:else}
			<section class="mb-5">
				<p class="mb-3">Step {currentStep}/10</p>
				<Progress currentProgress={currentStep} max={10} />
			</section>
			{#if currentStep === 1}
				<Step1 bind:currentStep bind:monthlyIncome />
			{:else if currentStep === 2}
				<Step2 {minimumEmergencyFund} bind:currentStep bind:sufficientEmergencyFund />
			{:else if currentStep === 3}
				<Step3 {minimumSavings} bind:currentStep bind:sufficientSavings />
			{:else if currentStep === 4}
				<Step4 {minimumCiInsurance} bind:currentStep bind:sufficientCiInsurance />
			{:else if currentStep === 5}
				<Step5 {minimumTpdInsurance} bind:currentStep bind:sufficientTpdInsurance />
			{:else if currentStep === 6}
				<Step6 {minimumInsuranceSpend} bind:currentStep bind:sufficientInsuranceSpend />
			{:else if currentStep === 7}
				<Step7 {minimumIncomeInvestment} bind:currentStep bind:sufficientIncomeInvestment />
			{:else if currentStep === 8}
				<Step8 bind:currentStep bind:sufficientNetworthInvestment />
			{:else if currentStep === 9}
				<Step9 bind:currentStep bind:sufficientCpfForFrs />
			{:else if currentStep === 10}
				<Step10 bind:currentStep bind:multipleIncomeStreams />
			{/if}
		{/if}
	</div>
</div>
